import React, { useContext, } from 'react';
import PropTypes from 'prop-types';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import {
  entityIs,
  anyComp,
} from '@bingads-webui-campaign-react/form-error';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getLocationTargetingStyles } from '@bingads-webui-campaign-react/location-targeting';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { SectionShimmer, getLocationTargetTitleDetails, ERROR_ENTITY } from '@bingads-webui-campaign-react/wizard-shared-components';

import { LocationImg } from './media';
import { ValidatedLocationTargetSetting } from './validated-location-target-setting';

const getTargetingStyles = () => ({
  container: {
    maxWidth: 680,
    '& .title-item': {
      width: 'unset !important',
    },
    '& .specific-location-targets-editor': {
      marginLeft: '-25px !important',
    },
    '& .intent-target ul': {
      paddingLeft: '20px',
    },
  },
  header: {
    marginBottom: 20,
  },
  ...getLocationTargetingStyles(),
});

const campaignLocationCriterions = anyComp(
  entityIs(ERROR_ENTITY.CampaignLocation),
  entityIs(ERROR_ENTITY.CampaignRadius),
  entityIs(ERROR_ENTITY.CampaignNegativeLocation),
  entityIs(ERROR_ENTITY.CampaignLocationIntent)
);

const ServerValidatedLocationTargetSetting = withControlErrorHandling(withUnvalidatedControlErrors(
  ValidatedLocationTargetSetting,
  { filter: campaignLocationCriterions }
));

export const LocationTargetingSettingPanel = (props) => {
  const { scope } = useContext(ScopeContext) || {};
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getTargetingStyles);

  const {
    key,
    isLoading,
    options,
    expand,
    data = {},
    topicKey,
    ...rest
  } = props;


  return (
    <ValidatedPanel
      key={key}
      title={<TextTitle
        titleKey={_TL_('Location')}
        topicKey={topicKey || 'pop_BA_Settings_LocationTargeting'}
        icon={LocationImg}
        details={
          getLocationTargetTitleDetails(
            i18n,
            data && data.locationTargets,
            false,
            data && data.BiddingScheme && data.BiddingScheme.Type,
            true
          )}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: key,
      }}
      {...rest}
    >
      {
        isLoading ?
          <SectionShimmer /> :
          <div className={classes.LocationTargeting}>
            <ServerValidatedLocationTargetSetting
              validationProps={{
                data: data && data.locationTargets,
              }}
              scope={scope}
              bidStrategyType={data && data.DisplayBiddingStrategyType}
              {...options}
            />
          </div>
        }
    </ValidatedPanel>
  );
};

LocationTargetingSettingPanel.propTypes = {
  key: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  options: PropTypes.shape({
    bundleCountries: PropTypes.arrayOf(PropTypes.shape({})),
    bundleLocationCriterions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  expand: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  topicKey: PropTypes.string,
};

LocationTargetingSettingPanel.defaultProps = {
  isLoading: false,
  options: {},
  data: {},
  topicKey: null,
};
